import styled from "styled-components";

export const PodcastsList = styled.ul`
  margin-top: 16px;

  .slick-list {
    @media (max-width: 1281px) {
      overflow: visible;
    }

    .slick-track {
      margin-left: 0;
      margin-right: 0;
    }
  }

  .slick-slide {
    div {
      margin-right: 6px;
    }
  }
`;

export const PodcastSkeleton = styled.span`
  min-height: 152px;
  max-height: 420px;
  aspect-ratio: 1/1.35;
`;
